/**
 * Single source of truth for sport display labels.
 *
 * Blast (and now the CRM) shows co-ed sports with NO gender word — "Football",
 * not "Co-Ed Football". Boys'/girls' sports keep their word. The CRM stores
 * Sport.name clean ("Football") and Sport.gender separately, so the label is
 * built here, in one place. See CRM-25.
 *
 * `gender` is typed `string` (not the Gender union) so every call site — some
 * of which type gender loosely — can adopt this without casts. Unknown values
 * fall through to '' (treated as co-ed: no word).
 */
export function genderLabel(gender: string): string {
  if (gender === 'BOYS') return 'Boys';
  if (gender === 'GIRLS') return 'Girls';
  return '';
}

/** "Boys Football" / "Girls Tennis" / "Football" (co-ed → name only, no leading space). */
export function formatSportLabel(gender: string, name: string): string {
  return [genderLabel(gender), name].filter(Boolean).join(' ');
}
